import React, { Component } from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import VisibilitySensor from 'react-visibility-sensor';
import Label from '../../components/Label';
import convertHtml from '../../utils/convertHtml';
import LazyImage from '../../components/lazy-image';
import Moment from 'react-moment';

const BlogHeaderContainer = styled.div`
  padding-top: ${props => props.height};
  //height: calc(100vh - (${props => props.height}));
  // max-height: calc(80vh - 35px);
  display: flex;
  flex-wrap: wrap;
  padding-top: 180px;
  margin-bottom: 70px;
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;

  @media (max-height: 850px) and (min-width: 1024px) {
    //min-height: 750px;
  }

  @media (max-width: 1000px) {
    //max-height: 500px;
  }
  @media (max-width: 1024px) {
    flex-wrap: wrap;
    height: unset;
    padding-top: ${props => props.mobileHeight};
    max-height: unset;
    margin-bottom: 0px;
  }
`;

const LeftContent = styled(motion.div)`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 1024px) {
    width: 100%;
    height: fit-content;
    padding-top: 35px;
    padding-bottom: 35px;
  }
`;

const RightContent = styled(motion.div)`
  width: 50%;
  @media (max-width: 1024px) {
    width: 100%;
    height: unset;
  }
`;

const MetaData = styled.div`
  width: 80%;
  max-width: 1440px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  @media (max-width: 1200px) {
    padding-left: 50px;
    width: 100%;
  }
  @media (max-width: 1024px) {
    padding: 0px;
    width: 90%;
  }
`;

const Title = styled.h1`
  font-family: DM Serif Text;
  font-style: normal;
  font-weight: 400;
  font-size: 48px;
  line-height: 64px;
  color: #404040;
  max-width: 80%;
  margin-bottom: 15px;
  @media (max-width: 1000px) {
    font-size: 36px;
    line-height: 44px;
  }
  @media (max-width: 1024px) {
    max-width: 100%;
  }
  @media (max-width: 450px) {
    font-size: 32px;
    line-height: 44px;
  }
`;

const Subtitle = styled(motion.div)`
  font-family: DM Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: -0.03em;
  max-width: 80%;
  color: #404040 !important;
  margin-bottom: 30px;
  @media (max-width: 1000px) {
    font-size: 21px;
    line-height: 30px;
  }
  @media (max-width: 1024px) {
    max-width: 100%;
  }
  @media (max-width: 450px) {
    font-size: 18px;
    line-height: 22px;
  }
`;

const LabelContainer = styled(motion.div)`
  div {
    color: #4758eb;
    border-color: #4758eb;
  }
  > div {
    border: 1px solid #4758eb;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  // max-height: 500px;
  margin-top: 30px;

  img {
    height: 100% !important;
    width: 100% !important;
    // max-height: 500px;
    object-fit: cover !important;
    object-position: top center !important;
  }
`;

const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: 500px;
  margin-top: 30px;
  video {
    height: 100% !important;
    width: 100% !important;
    max-height: 500px;
    object-fit: cover !important;
    object-position: top center !important;
  }
`;

const BlogLowerHeaderContainerOuter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    width: 100%;
    margin-bottom: 30px;
  }
`;

const BlogLowerHeaderContainer = styled.div`
  width: 100%;
`;

const AuthorInfoContainer = styled(motion.div)`
  display: flex;
  margin-top: 25px;
  height: 100px;
`;

const AuthorImageContainer = styled.div`
  border-radius: 50%;
  height: 85px;
  width: 85px;
  overflow: hidden;
  @media (max-width: 1024px) {
    height: 70px;
    width: 70px;
    min-width: 70px;
  }
`;

const ReadTime = styled.div`
  font-family: DM Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 23px;
  color: #404040;
  margin-left: 7.5px;
  @media (max-width: 1024px) {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 2.5px;
    margin-left: 4.5px;
  }
`;

const MetadataContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: -2.5px;
  @media (max-width: 1024px) {
    width: calc(100% - 70px);
  }
`;

const AuthorName = styled.div`
  font-family: DM Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 159.8%;
  margin-left: 30px;
  max-width: 350px;
  color: rgba(0, 0, 0, 0.7);
  strong {
    font-weight: bold;
  }
  @media (max-width: 1024px) {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 2.5px;
    margin-left: 15px;
  }
`;

const PostDate = styled.div`
  font-family: DM Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  margin-left: 0;
  line-height: 159.8%;
  clear: both;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 15px;
  display: block;

  @media (max-width: 1024px) {
    font-size: 12px;
    line-height: 14px;
  }
`;

const InnerMetadataContainer = styled.div`
  display: flex;
`;

const AuthorImageContainerOuter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LeftContentAnim = {};

const Dot = styled.div`
  font-size: 34px;
  line-height: 6px;
  font-family: roboto;
  color: #fe2e45;
  margin-left: 7.5px;
  @media (max-width: 1024px) {
    line-height: 0px;
    margin-top: -1px;
    margin-left: 4.5px;
  }
`;

const DividerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 50px;
`;

const Divider = styled.div`
  border: 1px solid #e5e5e5;
  width: 500px;
  max-width: 80%;
`;

const TitleAnim = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.25,
      duration: 0.2,
      ease: 'easeOut',
    },
  },
};

const SubtitleAnim = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.3,
      duration: 0.2,
      ease: 'easeOut',
    },
  },
};

const LabelAnim = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.2,
      duration: 0.2,
      ease: 'easeOut',
    },
  },
};

const AuthorAnim = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.4,
      duration: 0.2,
      ease: 'easeOut',
    },
  },
};

const RightContentAnim = {
  hidden: {
    opacity: 0,
    x: 25,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      delay: 0.5,
      duration: 0.2,
      ease: 'easeOut',
    },
  },
};
export class BlogHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      visible: false,
      visibilitySensorActive: true,
      readTimeLength: 0,
    };
  }

  handleVisibilityChange = visible => {
    if (this.state.visible !== visible) {
      this.setState({ visible, visibilitySensorActive: !visible });
    }
  };

  componentDidMount = () => {
    let totalText = ''; // Initialize as an empty string
    this.props.body.forEach((item, index) => {
      if (item.slice_type === 'paragraph_text') {
        totalText = totalText + item.primary.text_content.text;
      }
    });

    let wordsPerMinute = 200;
    let length = totalText.split(' ').length;
    let value = Math.ceil(length / wordsPerMinute);

    this.setState({
      readTimeLength: value,
    });
  };

  render() {
    return (
      <VisibilitySensor
        active={this.state.visibilitySensorActive}
        onChange={this.handleVisibilityChange}
        partialVisibility
        minTopValue={250}
      >
        <React.Fragment>
          <BlogHeaderContainer>
            <LabelContainer
              variants={LabelAnim}
              initial="hidden"
              animate={this.state.visible ? 'visible' : 'hidden'}
            >
              <Label
                color="#4758eb"
                text={this.props.labelText}
                mobileFontSize={'12px'}
              />
            </LabelContainer>
            <PostDate color="#404040">
              <Moment format="Do MMMM YYYY" withTitle>
                {this.props.postDate}
              </Moment>
              &nbsp;&nbsp;•&nbsp;&nbsp;Words by{' '}
              <strong>{this.props.author}</strong>{' '}
              {this.state.readTimeLength > 0 && (
                <>
                  &nbsp;&nbsp;•&nbsp;&nbsp;{this.state.readTimeLength} minute
                  read
                </>
              )}
            </PostDate>
            <Title
              dangerouslySetInnerHTML={convertHtml(this.props.title)}
              variants={TitleAnim}
              initial="hidden"
              animate={this.state.visible ? 'visible' : 'hidden'}
            />
            <Subtitle
              variants={SubtitleAnim}
              initial="hidden"
              animate={this.state.visible ? 'visible' : 'hidden'}
              dangerouslySetInnerHTML={convertHtml(this.props.subtitle)}
              color="#404040"
            />
            {this.props.video &&
            this.props.video.url &&
            this.props.video.url.includes('.mp4') ? (
              <VideoContainer>
                <video autoPlay loop playsInline muted>
                  <source src={this.props.video.url} type="video/mp4" />
                </video>
              </VideoContainer>
            ) : (
              <ImageContainer>
                {this.props.image && <LazyImage {...this.props.image} />}
              </ImageContainer>
            )}

            {/*<MetaData>
                <LabelContainer
                  variants={LabelAnim}
                  initial="hidden"
                  animate={this.state.visible ? 'visible' : 'hidden'}
                >
                  <Label
                    color={this.props.color}
                    text={this.props.labelText}
                    mobileFontSize={'12px'}
                  />
                </LabelContainer>
                <Title
                  dangerouslySetInnerHTML={convertHtml(this.props.title)}
                  variants={TitleAnim}
                  initial="hidden"
                  animate={this.state.visible ? 'visible' : 'hidden'}
                />
                <Subtitle
                  variants={SubtitleAnim}
                  initial="hidden"
                  animate={this.state.visible ? 'visible' : 'hidden'}
                  dangerouslySetInnerHTML={convertHtml(this.props.subtitle)}
                  color={this.props.color}
                />

                <AuthorInfoContainer
                  variants={AuthorAnim}
                  initial="hidden"
                  animate={this.state.visible ? 'visible' : 'hidden'}
                >
                  <AuthorImageContainerOuter>
                    <AuthorImageContainer>
                      {this.props.authorImage && (
                        <LazyImage {...this.props.authorImage} />
                      )}
                    </AuthorImageContainer>
                  </AuthorImageContainerOuter>
                  <MetadataContainer>
                    <AuthorName>
                      Words by <strong>{this.props.author}</strong>
                    </AuthorName>
                    <InnerMetadataContainer>
                      <PostDate color={this.props.color}>
                        <Moment format="ddd Do MMMM YYYY" withTitle>
                          {this.props.postDate}
                        </Moment>
                      </PostDate>
                      {this.state.readTimeLength > 0 && (
                        <>
                          <Dot>.</Dot>
                          <ReadTime color={this.props.color}>
                            {this.state.readTimeLength} minute read
                          </ReadTime>
                        </>
                      )}
                    </InnerMetadataContainer>
                  </MetadataContainer>
                </AuthorInfoContainer>
              </MetaData>*/}

            {/*<LeftContent
              variants={LeftContentAnim}
              initial="hidden"
              animate={this.state.visible ? 'visible' : 'hidden'}
            >
              <MetaData>
                <LabelContainer
                  variants={LabelAnim}
                  initial="hidden"
                  animate={this.state.visible ? 'visible' : 'hidden'}
                >
                  <Label
                    color={this.props.color}
                    text={this.props.labelText}
                    mobileFontSize={'12px'}
                  />
                </LabelContainer>
                <Title
                  dangerouslySetInnerHTML={convertHtml(this.props.title)}
                  variants={TitleAnim}
                  initial="hidden"
                  animate={this.state.visible ? 'visible' : 'hidden'}
                />
                <Subtitle
                  variants={SubtitleAnim}
                  initial="hidden"
                  animate={this.state.visible ? 'visible' : 'hidden'}
                  dangerouslySetInnerHTML={convertHtml(this.props.subtitle)}
                  color={this.props.color}
                />

                <AuthorInfoContainer
                  variants={AuthorAnim}
                  initial="hidden"
                  animate={this.state.visible ? 'visible' : 'hidden'}
                >
                  <AuthorImageContainerOuter>
                    <AuthorImageContainer>
                      {this.props.authorImage && (
                        <LazyImage {...this.props.authorImage} />
                      )}
                    </AuthorImageContainer>
                  </AuthorImageContainerOuter>
                  <MetadataContainer>
                    <AuthorName>
                      Words by <strong>{this.props.author}</strong>
                    </AuthorName>
                    <InnerMetadataContainer>
                      <PostDate color={this.props.color}>
                        <Moment format="ddd Do MMMM YYYY" withTitle>
                          {this.props.postDate}
                        </Moment>
                      </PostDate>
                      {this.state.readTimeLength > 0 && (
                        <>
                          <Dot>.</Dot>
                          <ReadTime color={this.props.color}>
                            {this.state.readTimeLength} minute read
                          </ReadTime>
                        </>
                      )}
                    </InnerMetadataContainer>
                  </MetadataContainer>
                </AuthorInfoContainer>
              </MetaData>
            </LeftContent>
            <RightContent
              variants={RightContentAnim}
              initial="hidden"
              animate={this.state.visible ? 'visible' : 'hidden'}
            >
              <ImageContainer>
                {this.props.image && <LazyImage {...this.props.image} />}
              </ImageContainer>
            </RightContent>*/}
          </BlogHeaderContainer>
          <DividerContainer>
            <Divider />
          </DividerContainer>
        </React.Fragment>
      </VisibilitySensor>
    );
  }
}

export default BlogHeader;
